import { Box, Typography } from '@mui/material';
import { useCallback } from 'react';
import { useProgressPortraitContext } from './ProgressPortraitProvider';
import { PatientProgress } from '../hook/ProgressPortraitStore';

export const PatientList = () => {
  const { store } = useProgressPortraitContext();
  const patients = store.patientList();
  return (
    <Box
      sx={{
        maxWidth: '100%',
        borderRadius: 8,
        backgroundColor: '#fff',
        display: 'inline-flex',
        flexWrap: 'nowrap',
        p: 3,
        gap: 5,
        overflow: 'auto',
      }}
      className='hide-scrollbar'
    >
      {patients.map((patient) => (
        <PatientItem
          patient={patient}
          isSelectedPatient={store.selectedPatientSfId === patient.sfId}
          key={patient.sfId}
        />
      ))}
    </Box>
  );
};

type PatientItemProps = {
  patient: PatientProgress;
  isSelectedPatient: boolean;
};
const PatientItem = ({ patient, isSelectedPatient }: PatientItemProps) => {
  const { dispatch } = useProgressPortraitContext();
  const selectPatient = useCallback(
    (patientSfId: string) => {
      dispatch({
        type: 'SELECT_PATIENT',
        patientSfId: patientSfId,
      });
    },
    [dispatch],
  );
  if (isSelectedPatient) {
    return (
      <Box
        sx={{
          flex: '0 0 auto',
          px: 8,
          py: 2,
          borderRadius: 5,
          backgroundColor: 'primary.main',
          boxShadow: 4,
        }}
      >
        <Typography color='primary.contrastText' fontWeight={600}>
          {patient.firstName}
        </Typography>
      </Box>
    );
  }
  return (
    <Box
      sx={{
        flex: '0 0 auto',
        px: 8,
        py: 2,
        borderRadius: 5,
        backgroundColor: '#fff',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'rgba(48, 127, 226, 0.1)',
        },
      }}
      onClick={() => selectPatient(patient.sfId)}
    >
      <Typography color='text.info'>{patient.firstName}</Typography>
    </Box>
  );
};
